import { ButtonList } from '@dixa/lib-shared-habla';
import type { SearchConversationEnriched } from 'lib-search-types';
import { ampli } from 'lib-shared-tracking';
import { MouseEventHandler, useCallback } from 'react';

import { useAppNavigate } from 'utils/url/useAppNavigate';

type ConversationsTableRowMenuActivityLogProps = {
  /** The conversation. */
  conversation: SearchConversationEnriched;
};

/** Represents the component for viewing the conversation activity log. */
export const ConversationsTableRowMenuActivityLog = ({
  conversation,
}: ConversationsTableRowMenuActivityLogProps): JSX.Element => {
  const navigate = useAppNavigate();

  /** Handles showing the activity log of the conversation. */
  const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>(() => {
    navigate({
      path: '/conversation/:csid/activity-log',
      params: { path: { csid: conversation.id.toString() } },
    });

    ampli.conversationActivityLogOpened({
      context: 'conversationsView',
    });
  }, [conversation.id, navigate]);

  return (
    <ButtonList.Item onClick={handleClick}>View activity log</ButtonList.Item>
  );
};
